// extracted by mini-css-extract-plugin
module.exports = {"tipCard":"tip-card_tipCard__LdcwX card_card__oDiig","ctaLink":"tip-card_ctaLink__mLj9e","captionLink":"tip-card_captionLink__vfyBF"};